import templateUrl from './scope-doc-view.html'
import './scope-doc-view.scss'

const ProjectScopeDocViewComponent = {
  bindings: {
    scopeDoc: '<',
    onItemFinishToggle: '&',
    onMarkAllComplete: '&',
    onMarkAllIncomplete: '&'
  },
  templateUrl,
  controller: class ProjectScopeDocView {
    constructor (UserService, EventEmitter) {
      'ngInject'
      this._identify = 'ProjectScopeDocViewComponent'
      this.UserService = UserService
      this.EventEmitter = EventEmitter
      this.isMarkAllProcessing = false
    }

    getAllItems () {
      const items = []
      this.scopeDoc.scopeDocItems.forEach(item => {
        items.push(item)
        item.scopeDocChildItems.forEach(child => items.push(child))
      })
      return items
    }

    get areAllComplete () {
      return this.scopeDoc && this.getAllItems().every(item => item.finishedAt)
    }

    get areAllIncomplete () {
      return this.scopeDoc && this.getAllItems().every(item => !item.finishedAt)
    }

    markAllComplete () {
      if (!this.UserService.isExpert() || this.isMarkAllProcessing) return
      const items = this.getAllItems().filter(item => !item.finishedAt)
      if (items.length === 0) return
      if (typeof this.onMarkAllComplete !== 'function') return

      this.isMarkAllProcessing = true
      this.onMarkAllComplete(this.EventEmitter({ items }))
        .finally(() => {
          this.isMarkAllProcessing = false
        })
    }

    markAllIncomplete () {
      if (!this.UserService.isExpert() || this.isMarkAllProcessing) return
      const items = this.getAllItems().filter(item => item.finishedAt)
      if (items.length === 0) return
      if (typeof this.onMarkAllIncomplete !== 'function') return

      this.isMarkAllProcessing = true
      this.onMarkAllIncomplete(this.EventEmitter({ items }))
        .finally(() => {
          this.isMarkAllProcessing = false
        })
    }

    toggleFinishedState (item) {
      if (this.UserService.isClient()) {
        return
      }

      if (typeof this.onItemFinishToggle === 'function') {
        item.toggleProcessing(true)
        this.onItemFinishToggle(this.EventEmitter({ item }))
          .then(response => {
            console.log('[ProjectScopeDocViewComponent] > onItemFinishToggle > response', response)
            // item.updateSelf(response) // if we would like that whole item is updated from BE

            item.finishedAt = response.finishedAt
          })
          .finally(() => {
            item.toggleProcessing(false)
          })
      }
    }
  }
}

export default ProjectScopeDocViewComponent
